import React from 'react'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ProductSegment } from 'constants/product/productTypes'
import { DropdownInputTypes, MUIDropdownInput } from 'components/common/MUIDropdownInput/MUIDropdownInput.component'
import { AREA_RANGES } from 'utils/purchaseFlow/segmentForSurface'

interface Props {
  areaRange: ProductSegment | null
  onAreaRangeChange: (areaRange: ProductSegment) => void
  /** Marks a missing range once the client tried to go on. */
  showErrors?: boolean
}

/** The property's size in the purchase flow drawer: a required area range, which prices the products. */
export const AreaRangeFields: React.FC<Props> = ({ areaRange, onAreaRangeChange, showErrors = false }) => {
  const { t } = useTranslation(['purchase_flow_revamp', 'segment'])

  // The band copy marks the squared unit for a superscript (`m<0>2</0>`); a select shows plain text.
  const rangeLabel = (range: ProductSegment) => t(`segment:${range}`).replace(/<0>2<\/0>/, '²')

  return (
    <Stack data-cy="pf-revamp-area-range">

      {/* A native select: reachable by keyboard and screen readers, and the platform picker on a phone. */}
      <MUIDropdownInput
        isNativeSelect
        isError={showErrors && !areaRange}
        label={t('purchase_flow_revamp:area_range_label')}
        type={DropdownInputTypes.SELECTOR}
        value={areaRange ?? ''}
        onChange={(e) => {
          const range = AREA_RANGES.find((candidate) => candidate === e.target.value)
          if (range) onAreaRangeChange(range)
        }}
      >

        <option value="" disabled>
          {t('purchase_flow_revamp:area_range_placeholder')}
        </option>

        {AREA_RANGES.map((range) => (
          <option key={range} value={range}>
            {rangeLabel(range)}
          </option>
        ))}

      </MUIDropdownInput>

    </Stack>
  )
}
